import { render, staticRenderFns } from "./TicketNavItem.vue?vue&type=template&id=682b8240&"
import script from "./TicketNavItem.vue?vue&type=script&lang=js&"
export * from "./TicketNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('682b8240')) {
      api.createRecord('682b8240', component.options)
    } else {
      api.reload('682b8240', component.options)
    }
    module.hot.accept("./TicketNavItem.vue?vue&type=template&id=682b8240&", function () {
      api.rerender('682b8240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/TicketNavItem.vue"
export default component.exports